import React, { useState, useEffect } from "react";
import Header from "../../component/loaderComponent/Header/Header";
import { HiMenu, HiX } from "react-icons/hi";
import Sidebar from "../Sidebar";
import './setting.scss';
import { changePasswordAction } from "../../actions/passwordAction";
import { useDispatch, useSelector } from "react-redux";
import { notify } from '../../services/notification';
import { FaEye, FaEyeSlash, FaCheck, FaTimes } from 'react-icons/fa';
import { MOBILE_BREAKPOINT, HTTP_STATUS } from "../../constants/constant";
import { PASSWORD_CRITERIA, getPasswordErrors, isPasswordValid as checkPasswordValid } from "../../utils/passwordValidator";
import useMobileView from "../../constants/useMobileView";
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { logoutAction } from "../../actions/logoutAction";
import { CLEAR_FIRST_LOGIN } from "../../actions/types";
import { clearFirstLoginCookie } from "../../utils/authCookies";

function Setting() {
  const [states, setDataStates] = useState({
    current_password: '',
    new_password: '',
    confirm_password: ''
  });



  const [error, setError] = useState({
    current_password_error: "",
    new_password_error: '',
    confirm_password_error: ''
  });


  const { isSidebarOpen, toggleSidebar } = useMobileView();

  const navigate = useNavigate();
  const [buttonClicked, setButtonClicked] = useState(false);
  const isFirstLogin = useSelector((state) => state.firstLogin?.isFirstLogin)
    || Cookies.get('is_first_login') === 'true';
  const [passwordVisibility, setPasswordVisibility] = useState({
    current: false,
    new: false,
    confirm: false
  });

  const dispatch = useDispatch();
  const [passwordTouched, setPasswordTouched] = useState(false);

  const passwordErrors = states.new_password ? getPasswordErrors(states.new_password) : PASSWORD_CRITERIA.map(c => c.key);
  const passwordValid = states.new_password ? checkPasswordValid(states.new_password) : false;
  const showMismatchError = states.confirm_password && states.new_password !== states.confirm_password;

  const handleChange = (evt) => {
    const { name, value } = evt.target;
    setDataStates(prevStates => ({
      ...prevStates,
      [name]: value.trim()
    }));
    if (name === 'new_password' && !passwordTouched) {
      setPasswordTouched(true);
    }
  };

  const togglePasswordVisibility = (field) => {
    setPasswordVisibility(prev => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  const validateForm = () => {
    let formIsValid = true;
    let errors = {};

    if (!states.current_password.trim()) {
      formIsValid = false;
      errors.current_password_error = "Please enter current password";
    }

    if (!states.new_password.trim()) {
      formIsValid = false;
      errors.new_password_error = "Please enter new password";
    } else if (!passwordValid) {
      formIsValid = false;
      errors.new_password_error = "New password does not meet criteria.";
    }

    if (!states.confirm_password.trim()) {
      formIsValid = false;
      errors.confirm_password_error = "Please enter confirm new password";
    } else if (states.new_password !== states.confirm_password) {
      formIsValid = false;
      errors.confirm_password_error = "Passwords do not match";
    }

    setError(errors);
    return formIsValid;
  };

  const handleLogout = async () => {
    try {
      let response = await dispatch(logoutAction());

      if (response.data.success === true) {
        Cookies.remove('accessToken');
        Cookies.remove('role');
        Cookies.remove('permissions');
        Cookies.remove('ispermission');
        Cookies.remove('username');
        Cookies.remove('vehicletype');
        Cookies.remove('csrftoken');
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } catch (error) {
      notify.error("Please try again.");
    }
  };


  const postChangePassword = async () => {
    if (validateForm()) {
      const apiReq = {
        old_password: states.current_password,
        new_password: states.new_password,
        confirm_password: states.confirm_password
      };

      setButtonClicked(true);
      try {
        const response = await dispatch(changePasswordAction(apiReq));

        if (response?.status === HTTP_STATUS.OK) {
          notify.success(response.data.message || "Password changed successfully");

          setDataStates({
            current_password: '',
            new_password: '',
            confirm_password: ''
          });

          if (isFirstLogin) {
            dispatch({ type: CLEAR_FIRST_LOGIN });
            clearFirstLoginCookie();
            window.scrollTo(0, 0);
            navigate('/', { replace: true });
          } else {
            window.scrollTo(0, 0);
            await handleLogout();
          }
        }
      } catch (error) {
        notify.error(error.response?.data?.message || "An error occurred. Please try again.");
      } finally {
        setButtonClicked(false);
      }
    }
  };

  return (
    <div className="setting_container">
      <div className="setting_container_right">
        <Header title="Settings" />
        <div className="password_heading">
          <span className="password_heading_text">
            Change Password
          </span>
        </div>
        <div className="password_container">
          <div className="password_current">
            <span className="password_span_text">Current Password</span>
            <div className="input-wrapper">
              <input
                type={passwordVisibility.current ? 'text' : 'password'}
                className="input_password"
                value={states.current_password}
                name="current_password"
                onChange={handleChange}
                placeholder="Enter current password"
              />
              <span
                className={`pass-icon ${passwordVisibility.current ? 'visible' : ''}`}
                onClick={() => togglePasswordVisibility('current')}
              >
                {passwordVisibility.current ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
            {error.current_password_error && (
              <span className="error-message">{error.current_password_error}</span>
            )}
          </div>
          <div className="password_newpassword">
            <span className="password_span_text">New Password</span>
            <div className="input-wrapper">
              <input
                type={passwordVisibility.new ? 'text' : 'password'}
                className="input_password"
                name="new_password"
                value={states.new_password}
                onChange={handleChange}
                maxLength={24}
                placeholder="Enter new password"
              />
              <span
                className={`pass-icon ${passwordVisibility.new ? 'visible' : ''}`}
                onClick={() => togglePasswordVisibility('new')}
              >
                {passwordVisibility.new ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
            {error.new_password_error && (
              <span className="error-message">{error.new_password_error}</span>
            )}
            {passwordTouched && !passwordValid && (
              <div className='password-criteria'>
                <p className='criteria-header'>Your password must have:</p>
                {PASSWORD_CRITERIA.map((criteria) => {
                  const isMet = !passwordErrors.includes(criteria.key);
                  return (
                    <div key={criteria.key} className={`criteria-item ${isMet ? 'met' : 'unmet'}`}>
                      {isMet ? <FaCheck className='criteria-icon met' /> : <FaTimes className='criteria-icon unmet' />}
                      <span>{criteria.label}</span>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
          <div className="password_confirm">
            <span className="password_span_text">Please confirm your new password</span>
            <div className="input-wrapper">
              <input
                type={passwordVisibility.confirm ? 'text' : 'password'}
                className="input_password"
                name="confirm_password"
                value={states.confirm_password}
                onChange={handleChange}
                disabled={!states.new_password}
                maxLength={24}
                placeholder="Confirm new password"
              />
              <span
                className={`pass-icon ${passwordVisibility.confirm ? 'visible' : ''}`}
                onClick={() => togglePasswordVisibility('confirm')}
              >
                {passwordVisibility.confirm ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
            {showMismatchError ? (
              <span className="error-message">Passwords do not match.</span>
            ) : (
              error.confirm_password_error && (
                <span className="error-message">{error.confirm_password_error}</span>
              )
            )}
          </div>
          <div className="password_button">
            <button
              className="password_send_button"
              disabled={buttonClicked}
              onClick={postChangePassword}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Setting;

